<kpd-secure-action-dialog key="secureDelete"></kpd-secure-action-dialog>
<div class="detail__grid">
  <div class="detail__alert"></div>
  <div class="detail__toolbar">
    <kpd-action-bar>
      <kpd-action-edit-toggle
        [readMode]="!readOnlyMode"
        (action)="toggleViewMode()"
        [disable]="loading || (isSystemUser && !hasSystemUserManagePermission)"
        *kpdPermission="Permissions.UserRoleUpdate"
      >
      </kpd-action-edit-toggle>
    </kpd-action-bar>
  </div>

  <div class="detail__main">
    <kpd-entity-not-assigned
      icon="users"
      [header]="'No roles assigned' | translate"
      [description]="'Edit this user to assign them available roles.' | translate"
      *ngIf="!loading && applicationsWithRoles && applicationsWithRoles.length === 0 && readOnlyMode"
    ></kpd-entity-not-assigned>

    <div *ngFor="let application of applicationsWithRoles" class="roles">
      <app-user-details-roles-application
        *ngIf="application.roles.length > 0"
        [application]="application"
        [readOnly]="readOnlyMode || loading"
        (toggle)="onToggle($event, application.name)"
      ></app-user-details-roles-application>
    </div>
  </div>
</div>
